import { render } from "./sidebar-link.vue?vue&type=template&id=528d5050"
import script from "./sidebar-link.vue?vue&type=script&lang=js"
export * from "./sidebar-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__